import { Skeleton, Box, Card, CardContent } from "@mui/material";

interface CardSkeletonProps {
  variant?: "analytics" | "list" | "detail";
  count?: number;
}

export const CardSkeleton = ({
  variant = "analytics",
  count = 1,
}: CardSkeletonProps) => {
  if (variant === "analytics") {
    return (
      <>
        {Array.from({ length: count }).map((_, index) => (
          <Card key={index} sx={{ height: "100%", borderRadius: "16px", border: "1px solid rgba(226,232,240,0.8)", boxShadow: "none" }}>
            <CardContent sx={{ p: 2.5 }}>
              <Box display="flex" justifyContent="space-between">
                <Box flex={1}>
                  <Skeleton width="60%" height={18} sx={{ mb: 2, borderRadius: 1 }} />
                  <Skeleton width="40%" height={36} sx={{ mb: 1.5, borderRadius: 1 }} />
                  <Skeleton width="30%" height={18} sx={{ borderRadius: 1 }} />
                </Box>
                <Skeleton variant="rounded" width={52} height={52} sx={{ borderRadius: "14px" }} />
              </Box>
            </CardContent>
          </Card>
        ))}
      </>
    );
  }

  return (
    <Card sx={{ borderRadius: "16px", border: "1px solid rgba(226,232,240,0.8)", boxShadow: "none" }}>
      <CardContent>
        <Skeleton variant="rounded" width="100%" height={118} sx={{ borderRadius: 2 }} />
      </CardContent>
    </Card>
  );
};

interface TableSkeletonProps {
  rows?: number;
  columns?: number;
}

export const TableSkeleton = ({
  rows = 5,
  columns = 5,
}: TableSkeletonProps) => {
  return (
    <Box>
      {/* Header */}
      <Box
        display="flex"
        gap={2}
        mb={2}
        p={2}
        bgcolor="grey.100"
        borderRadius={1}
      >
        {Array.from({ length: columns }).map((_, index) => (
          <Skeleton key={index} width={`${100 / columns}%`} height={30} />
        ))}
      </Box>
      {/* Rows */}
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <Box key={rowIndex} display="flex" gap={2} mb={1} p={2}>
          {Array.from({ length: columns }).map((_, colIndex) => (
            <Skeleton key={colIndex} width={`${100 / columns}%`} height={40} />
          ))}
        </Box>
      ))}
    </Box>
  );
};

interface ListSkeletonProps {
  items?: number;
}

export const ListSkeleton = ({ items = 5 }: ListSkeletonProps) => {
  return (
    <Box>
      {Array.from({ length: items }).map((_, index) => (
        <Box key={index} display="flex" gap={2} mb={2} p={2}>
          <Skeleton variant="circular" width={40} height={40} />
          <Box flex={1}>
            <Skeleton width="60%" height={20} sx={{ mb: 1 }} />
            <Skeleton width="40%" height={16} />
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export { };
